import React from "react";

interface CircularGradientCardProps {
  header: React.ReactNode;
  description: React.ReactNode;
  colorFrom?: string;
  colorTo?: string;
}

const CircularGradientCard: React.FC<CircularGradientCardProps> = ({
  header,
  description,
  colorFrom,
  colorTo 
}) => {
  return (
    <div
      className="relative w-full rounded-2xl overflow-hidden shadow-lg transition-all duration-300"
      style={{
        background: `linear-gradient(135deg, ${colorFrom}, ${colorTo})`,
        aspectRatio: "2 / 1",
      }}
    >
      {/* Circular 3D overlay layers */}
      <div className="absolute inset-0 overflow-hidden">
        {/* Large circle top right */}
        <div
          className="absolute rounded-full"
          style={{
            width: "60%",
            height: "120%",
            top: "-30%",
            right: "-15%",
            filter: "blur(2px)",
            transform: "translateZ(20px)",
          }}
        />
        
        {/* Medium circle top right */}
        <div
          className="absolute rounded-full"
          style={{
            width: "45%",
            height: "90%",
            top: "-20%",
            right: "5%",
            filter: "blur(1px)",
            transform: "translateZ(15px)",
          }}
        />

        {/* Large circle bottom left */}
        <div
          className="absolute rounded-full"
          style={{
            background: `radial-gradient(circle, rgba(218, 218, 218, 0.25), rgba(236, 236, 236, 0.1))`,
            width: "70%",
            height: "140%",
            bottom: "-50%",
            left: "-20%",
            filter: "blur(3px)",
            transform: "translateZ(25px)",
          }}
        />

        {/* Medium circle bottom left */}
        <div
          className="absolute rounded-full"
          style={{
            width: "50%",
            height: "100%",
            bottom: "-30%",
            left: "0%",
            filter: "blur(2px)",
            transform: "translateZ(18px)",
          }}
        />

        {/* Small accent circle top left */}
        <div
          className="absolute rounded-full"
          style={{
            background: `radial-gradient(circle, rgba(255, 255, 255, 0.25), rgba(255, 255, 255, 0.05))`,
            width: "30%",
            height: "60%",
            top: "-10%",
            left: "-5%",
            filter: "blur(1.5px)",
            transform: "translateZ(12px)",
          }}
        />

        {/* Subtle overlay for depth */}
        <div
          className="absolute inset-0"
          style={{
            background: `linear-gradient(180deg, rgba(0, 0, 0, 0.05) 0%, rgba(0, 0, 0, 0.02) 100%)`,
            mixBlendMode: "multiply",
          }}
        />
      </div>

      {/* Content */}
      <div className="relative flex flex-col h-full w-full items-center justify-center text-white text-center px-4 z-10">
        <span className="text-xl font-semibold drop-shadow-md mb-2">
          {header}
        </span>
        <span className="text-base drop-shadow-sm opacity-90">
          {description}
        </span>
      </div>
    </div>
  );
};

export default CircularGradientCard;
